import React from 'react'
import { Link } from 'react-static'

import ReactGA from 'react-ga'

class TeamMember extends React.Component {
  render() {
    const profileUrl =  require(`../static/img/${this.props.image}`)

    return (
      <React.Fragment>
        <div className="team-member">
          <div className="team-member__profile" style={{ backgroundImage: `url(${profileUrl})` }}></div>

          <h3 className="team-member__name">{this.props.name} {this.props.position && this.props.position.length > 0 &&
          <span>{this.props.position}</span>
          }</h3>

          <p className="team-member__bio copy--intro">{this.props.bio}</p>

          <ReactGA.OutboundLink
            className="team-member__contact team-member__contact--email copy--intro"
            eventLabel="mailto"
            to={`mailto:${this.props.email}`}>
            {this.props.email}
          </ReactGA.OutboundLink>

          <p className="team-member__contact team-member__contact--tel copy--intro">{this.props.tel}</p>
        </div>
      </React.Fragment>
    )
  }
}

export default TeamMember;



// WEBPACK FOOTER //
// /Users/terrymasher/Development/glenbeigh-ltd/src/components/Team-Member.js